import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { AssetsListingState } from './AssetsListingState';
import { SearchForm } from './SearchForm';

export type AssetsListing = {
  seriesListingState: AssetsListingState;
};

export const initialState: AssetsListing = {
  seriesListingState: new AssetsListingState(),
};

const seriesListingSlice = createSlice({
  name: 'seriesListing',
  initialState,
  reducers: {
    updateAssetSideBar: (state, action) => {
      state.seriesListingState.isSidebarShowing = action.payload;
    // console.log('state.seriesListingState', state.seriesListingState);
    },
    updateSearchForm: (state, action) => {
      state.seriesListingState.searchForm = action.payload;
    },
    updatePagination: (state, action) => {
    // console.log(action.payload);
      state.seriesListingState.pagination = action.payload;
    // console.log(state.seriesListingState.pagination);
    },
    updateLastSortSettings: (state, action) => {
      state.seriesListingState.lastSortSettings = action.payload;
    },
    reset: (state) => {
      state.seriesListingState.reset();
    },
    updateEditMultipleForm: (state, action) => {
      state.seriesListingState.editMultipleForm = action.payload;
    },
    updateCureentCommonModel: (state, action) => {
      state.seriesListingState.editMultipleForm.currentCommonModel = action.payload;
    },
    isEditMultipleFormSaving: (state, action) => {
      state.seriesListingState.editMultipleForm.isSaving = action.payload;
    },
    updatePlayListduration:(state, action) => {
      state.seriesListingState.playListDuration = action.payload;
    }
  },
});

export const {
  updateAssetSideBar,
  updateSearchForm,
  updatePagination,
  updateLastSortSettings,
  reset,
  updateEditMultipleForm,
  isEditMultipleFormSaving,
  updateCureentCommonModel,
  updatePlayListduration
} = seriesListingSlice.actions;

// export seriesListingSelector selector to get the slice in any component
export const seriesListingSelector = (state: RootState) => state.seriesListing;
// export The reducer
const seriesListingReducer = seriesListingSlice.reducer;
export default seriesListingReducer;
